import { NotificationService } from '../../shared/notification/notification.service';
import { TranslationService } from '../../shared/translation/translation.service';
import { DatagridService } from '../../shared/widgets/datagrid/datagrid.service';
import { SalesOpportunityService } from '../shared/sales-opportunity.service';
import { LazyLoadEvent, ConfirmationService } from 'primeng/api';
import { SalesOpportunitySearchDto } from '../shared/dto/sales-opportunity-search.dto';
import { PagedResultGeneric } from '../../shared/model/paged-result.model';
import { Component, OnInit, Input, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import { SalesOpportunityDto } from '../shared/dto/sales-opportunity.dto';
import { timeoutWrapper } from 'src/app/shared/decorator/timeout-wrapper';
import { UserService } from 'src/app/users/shared/user.service';
import { SecurityAccessLevelEnum } from 'src/app/shared/auth/enum/security-access-level.enum';

@Component({
  selector: 'wl-sales-opportunity-search-grid',
  templateUrl: './sales-opportunity-search-grid.component.html',
  styleUrls: ['./sales-opportunity-search-grid.component.less'],
  standalone: false,
})
export class SalesOpportunitySearchGridComponent implements OnInit, OnChanges {
  @Input() searchParams: SalesOpportunitySearchDto;

  @Output() completedSearch = new EventEmitter<PagedResultGeneric<SalesOpportunityDto>>();
  salesOpportunitySearchResult: PagedResultGeneric<SalesOpportunityDto>;
  loading = false;
  profileModuleFullAccess: boolean = false;
  profileContactsTabFullAccess: boolean = false;

  constructor(
    private _salesOpportunityService: SalesOpportunityService,
    private _datagridService: DatagridService,
    private _confirmationService: ConfirmationService,
    private _translationService: TranslationService,
    private _notificationService: NotificationService,
    private _userService: UserService
  ) {}

  ngOnInit() {
    this._userService.getCurrentUserSecurityElementAccessLevel('Profiles_Module').then((userAccessLevel: number) => {
      this.profileModuleFullAccess = userAccessLevel > SecurityAccessLevelEnum.ReadOnlyAccess;

      if (this.profileModuleFullAccess) {
        this._userService.getCurrentUserSecurityElementAccessLevel('ProfileContacts_Tab').then((userAccessLevel: number) => {
          this.profileContactsTabFullAccess = userAccessLevel > SecurityAccessLevelEnum.ReadOnlyAccess;
        });
      }
    });
  }

  ngOnChanges(simpleChanges: SimpleChanges) {
    if (simpleChanges.searchParams && this.searchParams) {
      this.search();
    }
  }

  public search() {
    this.loading = true;
    this._salesOpportunityService
      .searchPost(this.searchParams)
      .then((result) => {
        this.searchParams.TotalCount = result.TotalCount;
        this.salesOpportunitySearchResult = result;
        this.completedSearch.emit(result);
      })
      .finally(() => (this.loading = false));
  }

  @timeoutWrapper()
  lazyLoadSalesOpportunities(event: LazyLoadEvent) {
    this._datagridService.mapDatagridPagingToPagedSearch(event, this.searchParams);
    this.search();
  }

  confirmDeletion(salesOpp: SalesOpportunityDto) {
    this._confirmationService.confirm({
      message: this._translationService.getInstant('sales-opportunities.search.delete-confirmation-message'),
      accept: () => {
        this.deleteSalesOpp(salesOpp);
      },
      reject: () => {
        this._confirmationService.close();
      },
    });
  }

  private deleteSalesOpp(salesOpp: SalesOpportunityDto) {
    this._salesOpportunityService.delete(salesOpp.SalesID).then(
      () => {
        this.search();
      },
      (error) => {
        this._notificationService.httpError(error);
      }
    );
  }
}
